import React from "react";
import ImageOne from "../../images/cotton.png";
import ImageTwo from "../../images/OCR.png";
import ImageThree from "../../images/crop-seg.png";
import ImageFour from "../../images/money.png";
import ImageFive from "../../images/Scavenging100Particles.gif";
import ImageSix from "../../images/SolarSystem.gif";
import "./styles.scss";
import { useState } from "react";

const portfolioData = [
  {
    id: 2,
    name: "Cotton Disease Classification",
    image: ImageOne,
    description: "Cotton Plant Disease Detection \
    which provide farmers with efficient and\
    effective ways to monitor the farms.  \
    Trained and achieved accuracy of 97% with the\
    DenseNet model and deployed it on a web application\
    using Flask API.",
    link: "",
  },
  {
    id: 2,
    name: "P&ID Text Recognition",
    link: "",
    description: "OCR text extraction task for text\
    detection and recognition from P&ID diagrams.\
    Built text datasets for custom\
    EasyOCR training by extracting ground truth bounding\
    boxes from P&ID images and Labels.",
    image: ImageTwo,
  },
  {
    id: 2,
    name: "Drone Image Segmentation",
    image: ImageThree,
    link: "",
    description: "Calculating crop coverage area in drone images by segmenting the crops with \
    unsupervised segmentation methods and image processing technique for extracting pixels and mapping.\
    ",
  },
  {
    id: 2,
    name: "Banknote Detection",
    image: ImageFour,
    description: "Euro banknote detection system \
    to be deployed in AIoT device to assist visually impaired person’s daily life. \
    Yolov5 model is trained with 5,10,20,500 and 1000 Euros notes for detection.\
    The detected note number is converted to audio and report to the user.",
    link: "",
  },
  {
    id: 3,
    name: "Swarm Simulation",
    image: ImageFive,
    link: "",
    description: "A MATLAB simulation of the school of fish scavenging around the \
    different food sources using physics calculations and gradient descent. ",
  },
  {
    id: 3,
    name: "Solar System Rendering",
    image: ImageSix,
    link: "",
    description: "Simulation of Solar System by using \
    Python OpenGL shader programs and texture binding for Computer Graphics. ",
  },

];

const filterData = [
  {
    filterId: 1,
    label: "All",
  },
  {
    filterId: 2,
    label: "AI",
  },
  {
    filterId: 3,
    label: "Other",
  },
];

const Portfolio = () => {
  const [filteredvalue, setFilteredValue] = useState(1);
  const [hoveredValue, setHoveredValue] = useState(null);

  function handleFilter(currentId) {
    setFilteredValue(currentId);
  }

  function handleHover(index) {
    setHoveredValue(index);
  }

  console.log("====================================");
  console.log(hoveredValue);
  console.log("====================================");

  const filteredItems =
    filteredvalue === 1
      ? portfolioData
      : portfolioData.filter((item) => item.id === filteredvalue);

  console.log(filteredItems);

  return (
    <section id="portfolio" className="portfolio">
      <div className="portfolio__content">
        <div className="portfolio__content__header">
          <h1> My Recent Works </h1>
        </div>

        <ul className="portfolio__content__filter">
          {filterData.map((item) => (
            <li
              className={item.filterId === filteredvalue ? "active" : ""}
              onClick={() => handleFilter(item.filterId)}
              key={item.filterId}
            >
              {item.label}
            </li>
          ))}
        </ul>
        <div className="portfolio__content__cards">
          {filteredItems.map((item, index) => (
            <div
              className="portfolio__content__cards__item"
              key={`cardItem${item.name.trim()}`}
              onMouseEnter={() => handleHover(index)}
              onMouseLeave={() => handleHover(null)}
            >
              <div className="portfolio__content__cards__item__img-wrapper">
                <a>
                  <img alt="dummy data" src={item.image} />
                </a>
              </div>
              <div className="overlay">
                {index === hoveredValue && (
                  <div>
                    <p>{item.name}</p>
                    <button>{item.description}</button>
                    
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="portfolio__content__footer">
          <p> Copyright @ 2022 myatmyintzuthin </p>
        </div>
      </div>
    </section>
  );
};
export default Portfolio;
